import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DeviceService, UserService } from '@frontend/vanilla/core';
import { rxEffects } from '@rx-angular/state/effects';
import { BehaviorSubject, Observable } from 'rxjs';

import { ConfigProviderService } from '../../config-provider/config-provider.service';
import { CasinoCoreNpmParamsService } from '../../shared/casino-core-npm-params.service';
import { JackpotDataService } from '../../shared/jackpotdata-service';
import { PromotionsBannerService } from '../../shared/promotions-banner.service';

@Injectable({
    providedIn: 'root',
})
export class JackpotAndPromotionsService {
    jackpotGroupSubject = new BehaviorSubject<string>('');
    jackpotGroupObservable: Observable<any> = this.jackpotGroupSubject.asObservable();
    postloginfirstJackpotSortCall: boolean = false;
    globalJackpotPathSegment: string;

    private readonly rxEffects = rxEffects();
    private readonly route = inject(ActivatedRoute);
    private readonly user = inject(UserService);
    private readonly jackpotDataService = inject(JackpotDataService);
    private readonly configProviderService = inject(ConfigProviderService);
    private readonly casinoCoreNpmParamsService = inject(CasinoCoreNpmParamsService);
    private readonly promotionsBannerService = inject(PromotionsBannerService);
    private readonly deviceService = inject(DeviceService);

    onAppInit() {
        this.rxEffects.register(this.route.queryParams, (params: any) => {
            this.jackpotGroupSubject.next(params['jackpotgroupId']);
        });
    }

    setGlobalJackpotPathSegment(pathsegment: string) {
        this.globalJackpotPathSegment = pathsegment;
    }

    initiateJackpotFeedsAndGames() {
        const jackpotDataClientConfig: any = this.configProviderService.provideJackpotConfig();
        const feedCacheConfig: any = this.configProviderService.provideFeedCacheConfig();
        const casinoNpmParams = this.casinoCoreNpmParamsService.getcasinoCoreNpmParams();

        if (!this.user.isAuthenticated || (this.user.isAuthenticated && !this.postloginfirstJackpotSortCall)) {
            if (feedCacheConfig.enableJackpotFeed && !casinoNpmParams?.isDisableJackpotCalls) {
                this.jackpotDataService.startFeed();
            }
            if (jackpotDataClientConfig.enableJackpotSortGames) {
                this.jackpotDataService.fetchJackpotSortGames();
            }
            if (this.user.isAuthenticated) this.postloginfirstJackpotSortCall = true;
        }
    }

    getJackpotListFromWidget(jackpotWidget: any): any[] {
        const jackpots: any[] = [];
        jackpotWidget.forEach((jp: any) => {
            if (jp != null) {
                jackpots.push(jp.itemName);
            }
        });
        return jackpots;
    }

    getGlobalJackpotByLobbyType(lobbyType: string): string {
        if (!lobbyType) {
            return lobbyType;
        }
        const globaljackpotconfig = this.configProviderService.provideGlobalJackpotConfig();
        const isGJLobby = globaljackpotconfig.globalJackpotPathSegmentsArray.filter(
            (lobby: any) => lobby.lobbyType && lobby.lobbyType?.toLowerCase() == lobbyType?.toLowerCase(),
        );
        if (isGJLobby && isGJLobby.length > 0) {
            return lobbyType + '#' + this.globalJackpotPathSegment + '#';
        }
        return lobbyType;
    }

    initiateJackpotandPromotionBanner(casinoNpmParams: any) {
        const jackpotDataClientConfig: any = this.configProviderService.provideJackpotConfig();
        const promotionsBannerConfig: any = this.configProviderService.providePromotionsBannerConfig();
        const feedCacheConfig: any = this.configProviderService.provideFeedCacheConfig();
        if (!this.user.isAuthenticated || (this.user.isAuthenticated && !this.postloginfirstJackpotSortCall)) {
            if (feedCacheConfig.enableJackpotFeed && !casinoNpmParams?.isDisableJackpotCalls) {
                this.jackpotDataService.stopFeed();
                this.jackpotDataService.startFeed();
            }
            if (jackpotDataClientConfig.enableJackpotSortGames) {
                this.jackpotDataService.fetchJackpotSortGames();
            }
            if (this.user.isAuthenticated) this.postloginfirstJackpotSortCall = true;
        }
        if (promotionsBannerConfig?.isEnablePromotionsBanner && this.deviceService.isMobilePhone && casinoNpmParams.isDll) {
            this.promotionsBannerService.fetchPromotionsBannerData();
        }
    }
}
